import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Form, Button } from "react-bootstrap";

const ModuleDynamicMultiFilterDropdown = ({
  filterField,
  setFilter,
  appliedFilters,
  options,
  title = "Select Options",
}) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const dropdownRef = useRef(null);

  // 👇 Add [] suffix for query format like status[]=active
  const filterKey = `${filterField}[]`;

  // Sync with parent-applied filters
  useEffect(() => {
    const currentFilter =
      appliedFilters[filterKey] && Array.isArray(appliedFilters[filterKey])
        ? appliedFilters[filterKey]
        : [];
    setSelectedValues(currentFilter);
    setTempSelected(currentFilter);
  }, [appliedFilters, filterKey]);

  // Toggle checkbox (only updates temp state)
  const handleCheckboxChange = (value) => {
    let updated;
    if (tempSelected.includes(value)) {
      updated = tempSelected.filter((v) => v !== value);
    } else {
      updated = [...tempSelected, value];
    }
    setTempSelected(updated);
  };

  // Apply filter when user clicks submit
  const handleApply = () => {
    setSelectedValues(tempSelected);
    setFilter(filterKey, tempSelected);
  };

  // Clear selections
  const handleClear = () => {
    setTempSelected([]);
    setSelectedValues([]);
    setFilter(filterKey, []);
  };

  // Show selected items as labels
  const selectedLabels = options
    .filter((opt) => selectedValues.includes(opt.value))
    .map((opt) => opt.label)
    .join(", ");

  return (
    <Form.Group className="m-0 p-0">
      <Dropdown className="w-100" ref={dropdownRef}>
        <Dropdown.Toggle
          variant="light"
          className="w-100 text-start border form-select"
          style={{
            backgroundColor: "#eee",
            borderColor: "#ccc",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {selectedValues.length > 0
            ? selectedLabels
            : `${title.charAt(0).toUpperCase()}${title.slice(1)}`}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            maxHeight: "280px",
            overflowY: "auto",
            width: "100%",
            padding: "10px",
            backgroundColor: "#eee",
            borderColor: "#ccc",
          }}
        >
          {options && options.length > 0 ? (
            <>
              {options.map(({ label, value }, index) => (
                <Form.Check
                  key={index}
                  type="checkbox"
                  id={`${filterField}-${index}`}
                  label={label}
                  value={value}
                  checked={tempSelected.includes(value)}
                  onChange={() => handleCheckboxChange(value)}
                  className="mb-2"
                />
              ))}

              <div className="d-flex justify-content-end mt-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="me-2"
                  onClick={handleClear}
                >
                  Clear
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleApply}
                >
                  Apply
                </Button>
              </div>
            </>
          ) : (
            <p className="text-muted small text-center mb-0">No options</p>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};

export default ModuleDynamicMultiFilterDropdown;
